import { render, staticRenderFns } from "./InternalOrderDetails.vue?vue&type=template&id=4cdb3695"
import script from "./InternalOrderDetails.vue?vue&type=script&lang=js"
export * from "./InternalOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./InternalOrderDetails.vue?vue&type=style&index=0&id=4cdb3695&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports